import { SortBy } from 'tradera/state/services/touchweb-search-api';
import { v4 as uuidv4 } from 'uuid';

export enum QueryType {
    Category = 'Category',
    Search = 'Search',
    Popular = 'Popular'
}

export type ItemListType = {
    id: string;
    title: string;
    queryParams: Record<string, string>;
    queryType: QueryType;
    used?: boolean;
};

const topSearches =
    'svenskt+tenn+zundapp+lego+marimekko+märklin+omega+volvo+saab+puch+fjällräven+louis+vuitton+rolex+toteme+husqvarna+luftgevär+lisa+larson+moped+rodebjer+muminmugg+vintage+retro+pokemon+motorsåg+volvo+240+gustavsberg+seiko+arket+warhammer+gucci+iittala+nintendo+switch+barbie+rörstrand+chanel+volvo+amazon+ganni+odd+molly+taklampa+lampa+ralph+lauren+nikon+guld+amatörradio+festool+makita+dior+iphone';

export const itemQueries: ItemListType[] = [
    // Antique & Design category
    {
        id: uuidv4(),
        title: 'startPage_itemList_1',
        queryType: QueryType.Category,
        queryParams: {
            categoryId: '20',
            sortBy: SortBy.Relevance,
            fromNumberOfBids: '5',
            toNumberOfBids: '20'
        }
    },
    //Ended auctions search
    {
        id: uuidv4(),
        title: 'startPage_itemList_2',
        queryType: QueryType.Search,
        queryParams: {
            q: topSearches,
            queryScope: 'AnyWordsAnyOrder',
            sortBy: SortBy.Relevance,
            itemStatus: 'Ended',
            fromPrice: '300',
            toPrice: '2500'
        }
    },
    // BIN search
    {
        id: uuidv4(),
        title: 'startPage_itemList_3',
        queryType: QueryType.Search,
        queryParams: {
            q: topSearches,
            queryScope: 'AnyWordsAnyOrder',
            sortBy: SortBy.Relevance,
            itemType: 'FixedPrice',
            fromPrice: '200',
            fromNumberOfBids: '0',
            toNumberOfBids: '0'
        }
    },
    // Video games category
    {
        id: uuidv4(),
        title: 'startPage_itemList_4',
        queryType: QueryType.Category,
        queryParams: {
            categoryId: '30',
            sortBy: SortBy.Relevance,
            fromNumberOfBids: '5',
            toNumberOfBids: '20'
        }
    },
    // Most popular searches (listnings)
    {
        id: uuidv4(),
        title: 'startPage_itemList_5',
        queryType: QueryType.Popular,
        queryParams: {
            queryScope: 'AnyWordsAnyOrder',
            sortBy: SortBy.AddedOn
        }
    }
];
